<div class="spinner-wrapper">
  <div style="display: flex; flex-direction: column;align-items: center;">
    <mat-spinner strokeWidth="7" diameter="170"></mat-spinner>
    @if (message) {
      <div class="message">{{message}}</div>
    }
  </div>
</div>